import { Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

interface CustomTooltipProps extends TooltipProps {
	style?: React.CSSProperties;
}

const CustomTooltip = styled(({ className, style = {}, ...props }: CustomTooltipProps) => (
	<Tooltip {...props} style={style} classes={{ popper: className }} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 408,
		borderRadius: '8px',
		border: '1px solid #DDD',
		background: '#FDFDFD',
		color: 'var(--color-font-grey)',
		fontSize: '14px',
		fontWeight: 600,
		padding: '12px',
		textAlign: 'center',
		whiteSpace: 'pre-line',
	},
});

export default CustomTooltip;
